export const CONFIRM_ACC_REQ = "CONFIRM_ACC_REQ"
export const CONFIRM_ACC_SUCCESS = "CONFIRM_ACC_SUCCESS"
export const CONFIRM_ACC_FAILURE = "CONFIRM_ACC_FAILURE"